import React from 'react';
import { useSelector } from 'react-redux';
import MetricDetail from '../metric_detail';
import VrrCircleLoader from '../../../shared_components/vrr_circle_loader';
import { getAllMetrics } from '../../../../redux/overview/metrics/metricsActions';
import { getOverviewDMPreferences } from '../../../../redux/settings/settingAction';
import { TSetOfMetrics } from '../../../../redux/overview/metrics/types';
import './MetricPins.scss';

const MetricPins: React.FC = () => {
  const pinedMetrics = useSelector(getOverviewDMPreferences)?.pined_dimensions;
  const metrics = useSelector(getAllMetrics);
  return (
    <div className="metric-pins">
      {Array.isArray(pinedMetrics) &&
        pinedMetrics?.map((metric) => (
          <VrrCircleLoader
            key={metric}
            isEnable={!metrics[metric as keyof TSetOfMetrics]}
          >
            <MetricDetail type="pin" metric={metric} />
          </VrrCircleLoader>
        ))}
    </div>
  );
};

export default MetricPins;
